import React from "react";

const AppButton = ({
  icon,
  children,
  type = "button",
  className = "",
  disabled = false,
  errorMessage,
  showError = false,
  ...props
}) => {
  return (
    <div className="w-full flex justify-center items-center">
      {showError && disabled && (
        <p className="text-red-500 text-sm mb-2 ">{errorMessage}</p>
      )}
      <button
        className={`w-full p-[10px] md:py-2 md:px-4 lg:px-[40px] border border-transparent rounded-full shadow-sm text-[16px] font-semibold ${
          disabled ? "" : ""
        } ${className}`}
        {...props}
        disabled={disabled}
      >
        <span>{children}</span>
        {icon && (
          <div className="flex justify-center items-center h-6 lg:h-8 w-6 lg:w-8 rounded-full border border-white ml-1">
            <img src={icon} alt="Arrow" width={18.2} height={14} />
          </div>
        )}
      </button>
    </div>
  );
};

export default AppButton;
